import { Injectable } from '@angular/core';
import { ApiConfig } from './config.api';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DocumentResourceApi {
  constructor(private httpClient: HttpClient) {
  }

  delete(documentCode) {
    return this.httpClient.delete(ApiConfig.baseURL + 'api/documents?docCodes=' + documentCode);
  }

  downloadBenefitStatement(keyword: string, startDate: string, endDate: string, language: string) {
    const queryString = 'searchString=' + keyword + '&startDate=' + startDate + '&endDate=' + endDate + '&lang=' + language;
    this.openNewTab(ApiConfig.baseURL + 'api/documents/balance/general?' + queryString, true);
  }

  getCertificate(openNewTabStatus: boolean) {
    this.openNewTab(ApiConfig.baseURL + 'api/documents/certificate', openNewTabStatus);
  }

  getCertificateByKeyword(keyword: string, openNewTabStatus: boolean) {
    this.openNewTab(ApiConfig.baseURL + 'api/documents/certificate?searchString=' + keyword, openNewTabStatus);
  }

  download(downloadCode, filename, extension): Observable<Blob> {
    return this.httpClient.get(ApiConfig.baseURL + 'api/documents/download/' + downloadCode, {
      headers: ApiConfig.requestOptionsHeaderForDownload(filename, extension),
      responseType: "blob"
    });
  }

  getByKeyword(title, selectedProductId,  page, size) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/documents/page?title='
    + title
    + '&productId='
    + selectedProductId
    + '&page=' + page + '&size=' + size, {headers: ApiConfig.requestOptionsHeader});
  }

  upload(formData) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/documents/upload', formData);
  }

  downloadDataDetail(downloadCode) {
    this.openNewTab(ApiConfig.baseURL + 'api/documents/' + downloadCode, false)
  }

  openNewTab(url: string, openNewTab: boolean) {
    const linkTarget = (openNewTab ? '_blank' : '_self');
    window.open(url, linkTarget);
  }
}
